import React from "react"
import axios from 'axios'
import $ from "jquery";
import { MDCList } from '@material/list';
import { MDCRipple } from '@material/ripple';
import { MDCTextField } from '@material/textfield';
import { MDCTabBar } from '@material/tab-bar';
import Slider from '@material-ui/core/Slider';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import Button from '@material-ui/core/Button';
import TextField from '@material-ui/core/TextField';
import CircularProgress from '@material-ui/core/CircularProgress';
import InputAdornment from '@material-ui/core/InputAdornment';
import OutlinedInput from '@material-ui/core/OutlinedInput';
import Snackbar from '@material-ui/core/Snackbar';

class Tabs extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      selected: this.props.selected || 0
    }
  }

  getInitialState() {
    return {
      selected: this.props.selected || 0
    }
  }

  handleChange(index) {
    this.setState({ selected: index })
  }

  componentDidMount() {
    new MDCTabBar(document.querySelector("#rentTabs"))
    this.setState(this.getInitialState())
  }

  render() {
    return <div>
      <div className="mdc-tab-bar" role="tablist" id="rentTabs">
        <div className="mdc-tab-scroller">
          <div className="mdc-tab-scroller__scroll-area">
            <div className="mdc-tab-scroller__scroll-content">
              {this.props.children.map((elem, index) => {
                let buttonStyle = index == this.state.selected ? 'mdc-tab mdc-tab--active' : 'mdc-tab'
                let spanStyle = index == this.state.selected ? 'mdc-tab-indicator mdc-tab-indicator--active' : 'mdc-tab-indicator';
                return <button className={buttonStyle} role="tab" aria-selected="false" tabindex="-1" key={index} onClick={this.handleChange.bind(this, index)}>
                  <span className="mdc-tab__content">
                    <span className="mdc-tab__icon" aria-hidden="true"><i className={elem.props.icon}></i> </span>
                    <span className="mdc-tab__text-label">{elem.props.title}</span>
                  </span>
                  <span className={spanStyle}>
                    <span className="mdc-tab-indicator__content mdc-tab-indicator__content--underline"></span>
                  </span>
                  <span className="mdc-tab__ripple"></span>
                </button>
              })}
            </div>
          </div>
        </div>
      </div>
      <div>{this.props.children[this.state.selected]}</div>
    </div>
  }


}

class Panel extends React.Component {
  render() {
    return <div>{this.props.children}</div>
  }
}

class SIMList extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.loadSIMs()
  }

  render(props) {
    const { error, isLoaded, items } = this.props.state;
    if (error) {
      return <div>Ошибка: {error.message}</div>;
    } else if (!isLoaded) {
      return <CircularProgress />;
    } else {
      var isFirst = true
      return (
        <ul class="mdc-list mdc-list--two-line" id="sims" style={{ padding: "0px" }}>
          {items.map(item => {
            var el = (<li class={"mdc-list-item" + (isFirst ? " mdc-list-item--selected" : "")} tabindex="0" onClick={() => { this.props.setSelected(item) }}>
              <span class="mdc-list-item__ripple"></span>
              <i className={"mdc-list-item__graphic fas fa-lg fa-sim-card"}></i>
              <span class="mdc-list-item__text">
                <span class="mdc-list-item__primary-text">{item.number}</span>
                <span class="mdc-list-item__secondary-text">{item.op}</span>
              </span>
            </li>
            )
            isFirst = false
            return el
          })}
        </ul>
      );
    }
  }
}

const marks = [
  {
    value: 1,
    label: 'День',
  },
  {
    value: 2,
    label: '3 дня',
  },
  {
    value: 3,
    label: "Неделя",
  },
  {
    value: 4,
    label: '2 недели',
  },
  {
    value: 5,
    label: 'Месяц',
  },
];

function valuetext(value) {
  return `${value}`;
}

function valueLabelFormat(value) {
  return marks.findIndex((mark) => mark.value === value) + 1;
}

class SIMRentParams extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      service: 0,
      total: prices[1],
      open: false
    }
  }

  handleClick = () => {
    this.setState({open: true})
  }

  handleClose = (event, reason) => {
    if (reason === 'clickaway') return
    this.setState({open: false})
  }

  componentDidMount(){
   
  }

  componentDidUpdate() {
    try {
      new MDCTextField(document.querySelector('#numberField'))
      new MDCTextField(document.querySelector('#opField'))


    }
    catch { }
  }

  render(props) {

    const { selected } = this.props.state;
   
    if (!selected) return <div style={{ display: "flex" }}>
      <CircularProgress />
    </div>

    return <div>
<Snackbar
        anchorOrigin={{
          vertical: 'bottom',
          horizontal: 'left',
        }}
        open={this.state.open}
        autoHideDuration={6000}
        onClose={this.handleClose}
        message="Note archived"
        action={
          <React.Fragment>
            <Button color="secondary" size="small" onClick={this.handleClose}>
              UNDO
            </Button>
           
          </React.Fragment>
        }
      />
      <div style={{ width: "50%", display: "inline-flex" }}>
        <label class="mdc-text-field mdc-text-field--outlined" id="numberField" style={{ width: "100%", display: "inline-flex", marginRight: "4px" }}>
          <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="amountInput" value={selected.number} />
          <span class="mdc-notched-outline">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <span class="mdc-floating-label" id="my-label-id">Номер</span>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
        </label>
      </div>
      <div style={{ width: "50%", height: "56px", display: "inline-flex" }}>
        <label class="mdc-text-field mdc-text-field--outlined" id="opField" style={{ width: "100%", display: "inline-flex", marginLeft: "4px" }}>
          <input type="text" class="mdc-text-field__input" aria-labelledby="my-label-id" id="promoInput" value={selected.op} />
          <span class="mdc-notched-outline">
            <span class="mdc-notched-outline__leading"></span>
            <span class="mdc-notched-outline__notch">
              <span class="mdc-floating-label" id="my-label-id">Оператор</span>
            </span>
            <span class="mdc-notched-outline__trailing"></span>
          </span>
        </label>
      </div>
      <h3 className="ibox_title" style={{ marginTop: "10px", marginBottom: "4px", marginLeft: "-4px" }}>Срок аренды</h3>
      <div style={{ paddingLeft: "24px", paddingRight: "24px" }}>
        <Slider
          defaultValue={1}
          min={1}
          style={{ color: "#6610f2" }}
          max={5}
          aria-labelledby="discrete-slider-restrict"
          step={null}
          marks={marks}
          onChange={(event, newValue) => { this.setState({ total: prices[newValue] }) }}
        />
      </div>
      <h3 className="ibox_title" style={{ marginTop: "12px", paddingBottom: "8px", marginBottom: "8px", marginLeft: "-4px" }}>Используемый сервис</h3>
      <FormControl variant="outlined">
        <InputLabel id="demo-simple-select-outlined-label">Сервис</InputLabel>
        <Select
          labelId="demo-simple-select-outlined-label"
          id="demo-simple-select-outlined"
          value={this.state.service}
          onChange={(event) => { this.setState({ service: event.target.value }) }}
          label="Сервис" 
        >
          {services.filter(e=>!selected.used.includes(e)).map(e=><MenuItem value={e}>{e}</MenuItem>) }
        </Select>
      </FormControl>
      <h3 className="ibox_title" style={{ marginTop: "12px", paddingBottom: "6px", marginBottom: "6px", marginLeft: "-4px" }}>Итог</h3>
      <div style={{ width: "50%", display: "inline-flex", paddingRight: "3px" }}>  
        <FormControl variant="outlined">
          <InputLabel htmlFor="outlined-basic">Сумма</InputLabel>
          <OutlinedInput
            id="outlined-basic"
            type="number"
            label="Сумма"
            variant="outlined"
            value={this.state.total}
            InputProps={{
              readOnly: true,
            }}
            endAdornment={<InputAdornment position="end">$</InputAdornment>}
          />  </FormControl>
      </div>
      <div style={{ width: "50%", display: "inline-flex", paddingLeft: "3px" }}> <Button style={{ width: "100%", height: "54px" }} variant="contained" onClick={this.handleClick}>Заказать</Button></div>
    </div>

  }
}

class RentPage extends React.Component {
  constructor(props) {
    super(props);
    this.setSelected = this.setSelected.bind(this)
    this.loadSIMs = this.loadSIMs.bind(this)

    this.state = {
      error: null,
      isLoaded: false,
      items: [],
      selected: null,
    }
  }

  setSelected(selected) {
    this.setState({
      selected
    })
  }

  handleChange = (event, newValue) => {
    this.setState({
      value: newValue
    })
  }

  handleChangeIndex = (index) => {
    this.setState({
      value: index
    })
  }

  loadSIMs() {
    axios.get("https://nakrutkatop.com:443/api/rent/sims", { withCredentials: true })
      .then(res => {
        document.getElementById("simsBox").style.opacity = 1
        this.setState({
          isLoaded: true,
          items: res.data.sims,
          selected: res.data.sims[0]
        }, () => {
          const list = new MDCList(document.getElementById('sims'));
          list.singleSelection = true;
          const listItemRipples = list.listElements.map((listItemEl) => new MDCRipple(listItemEl));
        })
      })
  }

  componentDidMount() {

  }

  render(props) {

    return <div className="mdc-drawer-app-content mdc-top-app-bar--fixed-adjust icontent" >
      <main className="main-content" id="main-content">

        <h2 className="pageHeader">Аренда SIM</h2>

        <Tabs selected={0}>
          <Panel title="Арендовать" icon="fas fa-plus">   <div className="irow" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
            <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="simsBox">
              <h3 className="ibox_title">Доступные номера</h3>
              <div className="ibox_content" style={{ padding: "0" }}>
                <SIMList loadSIMs={this.loadSIMs} setSelected={this.setSelected} state={this.state} />
              </div>
            </div> 

            <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", margin: "8px", opacity: "1", transition: ".3s opacity, .3s visibility" }} id="paramsBox">
              <h3 className="ibox_title">Параметры аренды</h3>
              <div className="ibox_content" style={{ padding: "8px" }}>
                <SIMRentParams state={this.state} />
              </div>
            </div>
          </div>
          </Panel>

          <Panel title="Активные" icon="fas fa-clock">
            <div className="irow" style={{ display: "flex", flexWrap: "wrap", paddingTop: "16px" }}>
              <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", opacity: "1", margin: "8px", transition: ".3s opacity, .3s visibility" }} id="simsBox">
                <h3 className="ibox_title">Активные номера</h3>
                <div className="ibox_content" style={{ padding: "0" }}>
                  <SIMList loadSIMs={this.loadSIMs} setSelected={this.setSelected} state={this.state} />
                </div>
              </div>

              <div className="ibox" style={{ width: "600px", flex: "0 0 600px", maxWidth: "100%", margin: "8px", opacity: "1", transition: ".3s opacity, .3s visibility" }} id="paramsBox">
                <h3 className="ibox_title">Информация</h3>
                <div className="ibox_content" style={{ padding: "8px" }}>
                  <SIMRentParams state={this.state} />
                </div>
              </div>
            </div>
          </Panel>

          <Panel title="Использованные" icon="fas fa-history">3</Panel>
        </Tabs>



      </main>
    </div>
  }
}
//   <SIMRentParams state={this.state} />
export default RentPage

const prices = [0, 50, 100, 200, 300, 400]

const services = ["Telegram", "Instagram", "ВКонтакте", "Facebook", "Twitter", "Mail.ru", "Avito", "Юла", "Все другие"]